import React, { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../../component/breadcrumb/Breadcrumb";
import Spinner from "../../../component/loadingbar/Spinner";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import Swal from "sweetalert2";
import { triggerNotification } from "../../../component/message/Msg";
import TableViewer from "../../../component/tableViewer/TableViewer";
// import noImg from "../../../assetsCon/assets/images/icons/no-image.png";

const ViewEmployees = () => {
  const token = config.token;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [employees, setEmployees] = useState([]);

  //  ------For TableViewer ------
  const employeesRef = useRef([]);
  employeesRef.current = employees;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------
  //--------------------------------------------------------- get sales employee ---------------------------------------------------------r
  useEffect(() => {
    setLoading(true);
    fetch(`${config.host_url}sales/`, {
      method: "GET",
      headers: {
        token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          console.log(data.data);
          setEmployees(data.data);

          //  ------For TableViewer ------
          const employeesData = data.data.map((emp) => ({
            employee: emp.first_name + " " + emp.last_name,
            image: emp.profile,
            employee_type: emp.sales_emp_type,
            email: emp.email,
            parent_employee: emp.perent_first_name + " " + emp.perent_last_name,
            idNumber: emp.sid,
          }));
          setRowData(employeesData);
          //  ------For TableViewer ------

          setLoading(false);
        }
      });
  }, [token]);

  // ---------------------------------------------------- Delete employee ---------------------------------------------------------D
  // Show a confirmation dialog
  const handleDeleteBtn = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete employee. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteEmployee(deleteId, i);
      }
    });
  };

  //If confirm then delete employee
  const handleDeleteEmployee = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}sales/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            triggerNotification("success", "employee deleted successfully.");

            //  ------For TableViewer ------
            const updatedemployees = [...employeesRef.current];
            updatedemployees.splice(i, 1);
            setEmployees(updatedemployees);
            const employeesData = updatedemployees.map((emp) => ({
              employee: emp.first_name + " " + emp.last_name,
              image: emp.profile,
              employee_type: emp.sales_emp_type,
              email: emp.email,
              parent_employee:
                emp.perent_first_name + " " + emp.perent_last_name,
              idNumber: emp.sid,
            }));
            setRowData(employeesData);
            //  ------For TableViewer ------
          } else if (data.status === 401) {
            // Invalid Token
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error deleting employee");
    }
  };

  //----------------------------------------------- redir to  emoloyee detail -------------------------------------------------
  const handleShowBtn = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewemployee/${encodedId}`);
  };

  //----------------------------------------------- update / edit employee (redir to add employee)  -------------------------------------------------
  const handleEditBtn = (id) => {
    navigate(`/addemployee/${btoa(encodeURIComponent(id))}`);
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Employee",
      field: "employee",
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image}
            alt="employee_Image"
            className="rounded h-11 w-11  mr-4"
          />
          <p className="p-0 m-0">{params.data.employee}</p>
        </div>
      ),
    },
    { field: "email", filter: true },
    { field: "employee_type", filter: true },
    { field: "parent_employee", filter: true },
  ];
  //  ------For TableViewer ------

  return (
    <>
      <Breadcrumb txt="Manage Employee" subpath={["View Employees"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Employees</h5>
            <div>
              <button
                type="button"
                className="btn btn-primary ml-4"
                onClick={() => {
                  navigate("/addemployee");
                }}
              >
                Add Employee
              </button>
            </div>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3 row mx-4  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData}
                colDefs={colDefs}
                onEdit={handleEditBtn}
                onDelete={handleDeleteBtn}
                onView={handleShowBtn}
                // haveImage
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewEmployees;
